import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faComment } from '@fortawesome/free-solid-svg-icons';
import eatsIcon from '../../assets/images/tab-icon-eats.svg';
import searchIcon from '../../assets/images/tab-icon-search.svg';
import ordersIcon from '../../assets/images/tab-icon-orders.svg';
import accountIcon from '../../assets/images/tab-icon-account.svg';

import eatsIconSelected from '../../assets/images/tab-icon-eats-selected.svg';
import searchIconSelected from '../../assets/images/tab-icon-search-selected.svg';
import ordersIconSelected from '../../assets/images/tab-icon-orders-selected.svg';
import accountIconSelected from '../../assets/images/tab-icon-account-selected.svg';

class NavigationTabs extends React.Component {


    openSupportWindow() {
        window.open("https://click2order.ca/support/customer-support");
    }


    render() {
        return (
            <div className="navigation-tabs">
                <Link className={(this.props.section == 'eats') ? "nav-link nav-selected" :  "nav-link"} to={'/'+this.props.sitename+'/'+this.props.lid+"/order"}>
                    <img src={(this.props.section == 'eats') ? eatsIconSelected :  eatsIcon} className="nav-icon" />
                    <div>Eats</div>
                </Link> 
                <Link className={(this.props.section == 'orders') ? "nav-link nav-selected" :  "nav-link"} to={'/'+this.props.sitename+'/'+this.props.lid+"/history"}>
                    <img src={(this.props.section == 'orders') ? ordersIconSelected :  ordersIcon} className="nav-icon" />
                    <div>Orders</div>
                </Link> 
                <Link className={(this.props.section == 'account') ? "nav-link nav-selected" :  "nav-link"} to={'/'+this.props.sitename+'/'+this.props.lid+"/account"}>
                    <img src={(this.props.section == 'account') ? accountIconSelected :  accountIcon} className="nav-icon" />
                    <div>Account</div>
                </Link>
                <Link onClick={this.openSupportWindow} className={(this.props.section == 'support') ? "nav-link nav-selected" :  "nav-link"} to={'/'+this.props.sitename+'/'+this.props.lid+"/account"}>
                    <FontAwesomeIcon icon={ faComment} light className="nav-icon" style={{ color: '#3a81b7', width: 28, height: 28 }} />
                   
                    <div>Support</div>
                </Link> 

                {/* <Link className={(this.props.section == 'account') ? "nav-link nav-selected" :  "nav-link"} to={'/'+this.props.lid+"/status"}>
                    <div>Status</div>
                </Link>  */}
                
                

            </div>
        );
    }
}

export default connect()(NavigationTabs);
